import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { MoveDesignDocument } from './move.generated';

export const useMoveDesign = (options: ApiOptions<typeof MoveDesignDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(MoveDesignDocument, {
    ...useNotifications(MoveDesignDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.designs.move_success'),
    }),
    ...options,
  });
};
